<template>
	<div class="projetopendente">
		<loader object="#df3e46" v-show="progress" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>
		<div class="container-fluid">
		<ol class="breadcrumb-arrow">
		  <li>
			<a href="/home"><i class="fa fa-home"></i></a>
			<a href="/projeto-listagem">Projetos</a>
		  </li>
		  <li>
			<a href="#">Pendentes
			  </a>
		  </li>
		</ol>
		</div>
		<div class="container-fluid mt-2">
			<div class="container-fluid mt-2">
				<div class="card">
					<div class="card-body">
						<div class="row ml-0 mr-0 page-header-title">
							<div class="col-lg-10 col-sm-6 pr-0 pl-0 d-none d-sm-block d-lg-block d-xl-block">
								<h2 class="text-header txt-bloqueio">Projetos pendentes</h2>
							</div>
							<div class="col-lg-2 col-sm-2 nput-search pl-0 nput-group d-flex pr-0">
								<input class="input-pesquisa-imprimir inputiPad search-menu"
									placeholder="Pesquisar..."
									v-model="filtroTipo"
									@keyup="filtrarProjeto" />
							</div>
						</div>
						<div id="accordionPendentes">
							<table class="table table-hover">
								<thead style="background-image: linear-gradient(to left, white, #f2f2f2)">
									<tr>
										<th width="90%">Projeto</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(pendente, index) in listaProjeto" :key="pendente.projeto.idprojeto">
										<td  	class="clickable"
												:id="`heading` + index"
												data-toggle="collapse"
												:data-target="`#collapse` + index"
												aria-expanded="true"
												:aria-controls="`collapse` + index">
													
												<strong>{{ pendente.projeto.nomeCodigo }}</strong>

											<div :id="`collapse` + index"
												class="w-100 collapse mt-3"
												:aria-labelledby="`heading` + index"
												data-parent="#accordionPendentes">		

												<div class="row p-1">
													<div class="col-6">
														<div class="row p-1">
															<div class="col-12">
																<strong>Período:</strong> {{pendente.projeto.dataInicio}} <strong>a</strong> {{pendente.projeto.dataFim}}
															</div>
														</div>
														<div class="row p-1">
															<div class="col-2">
																<strong>Criado por:</strong> 
															</div>
															<div class="col-1">
																<img :src="pendente.projeto.criador.avatar" :title="pendente.projeto.criador.nome" width="27" class="rounded-circle mr-2 mt-n1">
															</div>
															<div class="col">
																{{pendente.projeto.criador.apelido}}
															</div>
														</div>
														<div class="row p-1">
															<div class="col-7">
																<strong>Classificação:</strong> {{pendente.projeto.classificacao}}
															</div>
															<div class="col-5">
																<strong>Relevância:</strong> {{pendente.projeto.relevanciaCriador}}
															</div>
														</div>
														<div class="row p-1">
															<div class="col-7">
																<strong>Grupo(s) de Trabalho:</strong> <br/>
																<span class="ml-2" v-for="gt in pendente.projeto.listaGrupoTrabalho" :key="gt.idgt">
																	- {{gt.nome}}<br/>
																</span>
															</div>
															<div class="col-5">
																<strong>Responsável(is):</strong> <br/>
																<div class="row mt-1 mb-2" v-for="r in pendente.projeto.listaResponsavel" :key="r.idusuario">
																	<div class="col-1">
																		<img :src="r.avatar" :title="r.nome" width="27" class="rounded-circle mr-2 mt-n1">
																	</div>
																	<div class="col ml-3">
																		{{r.apelido}}
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div class="col-6" style="border-left: 1px solid #C0C0C0">
														<strong>Validações:</strong> <br/>
														<div class="row" v-for="v in pendente.listaValidacao" :key="v.idprojetovalidacao">

															<div class="col-10 ml-2" v-if="v.coordenacao == null">
																<span class="text-wrap">
																	&nbsp;&nbsp;{{ v.usuario.nome }}
																</span>
															</div>
															<div class="col-10 ml-2" v-if="v.coordenacao != null">
																<span class="text-wrap">
																	&nbsp;&nbsp;{{ v.coordenacao.nome }} - {{ v.coordenacao.sigla }}
																</span>
															</div>
															<div class="col-1">
																<el-tooltip :content="`Aceito `+ v.tempoDataHora" placement="top" v-if="v.respondido && v.validado">
																	<i class="far fa-thumbs-up text-success"></i>
																</el-tooltip>
																<el-tooltip :content="`Negado `+ v.tempoDataHora" placement="top" v-if="v.respondido && !v.validado">
																	<i class="far fa-thumbs-down text-danger"></i>
																</el-tooltip>
																<el-tooltip content="Pendente" placement="top" v-if="!v.respondido">
																	<i class="far fa-clock"></i>
																</el-tooltip>
															</div>
															<div class="col-11 ml-4 mb-2" style="white-space: normal; word-break: break-word;" v-if="v.justificativa != null">
																<strong>Justificativa:</strong> "{{ v.justificativa }}"
															</div>
														</div>
													</div>
												</div>
												<div class="w-100 mt-2 text-center">
													<el-tooltip content="Alterar esse projeto para nova validação" placement="top">
														<button class="mr-3 btn btn-info" @click.prevent="alterarProjeto(pendente.projeto)">
															<i class="fas fa-edit mr-3"></i>
															Alterar Projeto
														</button>
													</el-tooltip>
													<el-tooltip content="Finalizar totalmente esse projeto" placement="top">
														<button class="ml-3 btn btn-danger" @click="modalCancelarProjeto(pendente.projeto)">
															<i class="fas fa-calendar-times mr-3"></i>
															Cancelar Projeto
														</button>
													</el-tooltip>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

			</div>
		</div>

        <modal :show.sync="modals.modalCancelarProjeto">
            <form class="ml-3 mt-3 mr-3 mb-3">
                <h4 class="text-center">Cancelar Projeto</h4>
                <div class="row">

                    <div class="col">
                        <label for="inputTitulo">
                            Justificativa do cancelamento
                            <el-tooltip content="Campo obrigatório" placement="top">
                                <i style="font-size: 12px" class="fas fa-exclamation-circle text-info ml-1"></i>
                            </el-tooltip>
                        </label>
                        <div class="input-group">
                            <div class="input-group-prepend mb-2">
                                <span class="input-group-text"><i class="fas fa-align-left"></i></span>
                            </div>
                            <textarea rows="2" 
                                v-model="projetoCancelar.justificativa"
                                class="form-control mb-2"
                                maxlength="200"
                                placeholder="Preencha a justificativa"></textarea>
                        </div>
                    </div>
                </div>
                <br class="clear" />
                <div class="row">
                    <div class="col text-center mt-3">
                        <button type="button" @click="fecharModalCancelarProjeto()" class="btn btn-danger mr-3">
							Desistir
                        </button>
                        <button type="button" @click="cancelarProjeto()" class="btn btn-success ml-3">
                            Salvar
                        </button>
                    </div>
                </div>
            </form>
        </modal>

	</div>
</template>

<script>
const customLabels = {
	first: "<<",
	last: ">>",
	previous: "<",
	next: ">",
};

const defaultStyles = {
	ul: {
		margin: 0,
		padding: 0,
		display: "inline-block",
	},
	li: {
		listStyle: "none",
		display: "inline",
		textAlign: "center",
	},
	a: {
		cursor: "pointer",
		padding: "7px 7px",
		display: "block",
		float: "left",
	},
};

export default {
  components: {},
  created() {
    this.carregarProjetosPendentes();
  },
	data() {
		return {
			pageOfItems: [],
			progress: true,
			listaProjeto: [],
			listaProjetoFiltro: [],
			filtroTipo: "",
			customLabels,
			defaultStyles,
			projeto: {},
            projetoCancelar: {},
			modals: {
				modalCancelarProjeto: false,
			},
		};
	},
	methods: {
		onChangePage(pageOfItems) {
			this.pageOfItems = pageOfItems;
		},
		filtrarProjeto() {
			if (this.filtroTipo === "") {
				this.listaProjeto = this.listaProjetoFiltro;
			} else {
				this.listaProjeto = this.listaProjetoFiltro.filter((item) => {
					return (
						item.projeto.nomeCodigo.toUpperCase().indexOf(this.filtroTipo.toUpperCase()) >= 0
					);
				});
			}
		},
		alterarProjeto(projeto) {
			const options = {
				title: "Confirmação",
				okLabel: "Confirmar",
				cancelLabel: "Não",
			};
			this.$dialogs.confirm('Deseja ir para o cadastro de alteração desse projeto?', options)
				.then((res) => {
				if (res.ok) {
					location.href = '/projeto-cadastro/'+ projeto.idprojeto;
				}
			});

		},
        modalCancelarProjeto(projeto) {
            let projetoCancelar = {
                idprojeto: projeto.idprojeto
            }
            this.projetoCancelar = projetoCancelar;
            this.projetoCancelar.justificativa = null;
            this.modals.modalCancelarProjeto = true;
        },
        fecharModalCancelarProjeto() {
            this.modals.modalCancelarProjeto = false;
        },
		cancelarProjeto() {
			if (this.validaProjetoCancelar()) {
				const options = {
					title: "Confirmação",
					okLabel: "Confirmar",
					cancelLabel: "Não",
				};
				if (confirm('Deseja realmente cancelar esse projeto em definitivo?')) {
					this.progress = true;
					this.modals.modalCancelarProjeto = false;
					this.$clubApi.post("/projeto/cancelar/", this.projetoCancelar).then(() => {
						this.carregarProjetosPendentes();
						this.$toastr.success("Projeto cancelado com sucesso!");
					})
					.catch((error) => {
						this.$toastr.warning(error.response.data.msg);
						this.progress = false;
					}).finally(() => {
						this.projetoCancelar = {};
					});
				}
			}
		},
		validaProjetoCancelar() {
			var camposValidos = true;
			if (this.projetoCancelar.justificativa == null ||
                    this.projetoCancelar.justificativa.trim() == "") {
				this.$toastr.error("Justificativa do cancelamento do Projeto obrigatória!");
				camposValidos = false;
			}
			return camposValidos;
		},
		carregarProjetosPendentes() {
			this.progress = true;
			this.$clubApi.get("/projeto/pendente").then((response) => {
				this.listaProjeto = response.data.object;
				this.listaProjetoFiltro = response.data.object;
			})
			.catch((error) => {
				this.$toastr.error(error.response.data.msg);
			})
			.finally(() => {
				this.progress = false;
			});
		},
	}
}
</script>
<style scoped>
.container-fluid { padding-left: 10px !important; padding-right: 10px !important; }
.clickable {
  cursor: pointer;
}
.clickable:hover {
  cursor: pointer;
  text-decoration: none;
}
</style>
